// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"WelcomePage_contentWrapper__1c5W4","welcomeImage":"WelcomePage_welcomeImage__2Fk5f","email":"WelcomePage_email__31KWY"};